import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FriendsTop } from '../../widgets/friends-top';
import { FriendsList } from '../../widgets/friends-list/ui/friends-list';
import s from './friends.module.scss';
export const Friends = () => (_jsxs("div", { className: s.friends, children: [_jsx(FriendsTop, {}), _jsx(FriendsList, {})] }));
